import React from 'react';

/**
 * Simple, accessible color picker for the Event Title text.
 * Uses the native browser color input (often rendered as a color wheel)
 * plus a hex value input for precision.
 */
const TitleColorPicker = ({ value, onChange, label, id }) => {
  const inputId = id || 'event-title-color-picker';
  const safeValue =
    (typeof value === 'string' && value.trim()) || '#111827';

  const handleColorChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const handleTextChange = (e) => {
    const next = e.target.value;
    // Allow user to type freely; only basic validation that it starts with #
    if (!onChange) return;

    if (!next || next.startsWith('#')) {
      onChange(next);
    }
  };

  return (
    <div className="title-color-picker">
      {label && (
        <label htmlFor={inputId} className="landing-label">
          {label}
        </label>
      )}
      <div className="title-color-picker-row">
        <button
          type="button"
          className="title-color-swatch"
          aria-label="Current event title color preview"
          style={{ backgroundColor: safeValue }}
        />
        <input
          id={inputId}
          type="color"
          className="title-color-input"
          value={safeValue}
          onChange={handleColorChange}
          aria-label="Choose event title color"
        />
        <input
          type="text"
          className="title-color-hex-input"
          value={safeValue}
          onChange={handleTextChange}
          aria-label="Event title color hex value"
          spellCheck="false"
        />
      </div>
    </div>
  );
};

export default TitleColorPicker;

